<template>
  <div id="faq" class="container max-w-5xl px-4 py-12 mx-auto mb-5">
    <!-- FAQ Section -->
    <div class="mt-16 bg-gray-800 text-gray-200 p-8 rounded-lg">
      <h2 class="text-3xl font-bold text-center mb-6">Frequently Asked Questions</h2>
      <div class="space-y-6 flex-auto">
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">What is Untouchable Guys?</summary>
          <p class="mt-2">
            Untouchable Guys is more than a memecoin—it's a community-driven movement built to celebrate resilience, creativity, and the untouchable spirit. Join us and meme your way to greatness.
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">How can I join the Untouchable Guys community?</summary>
          <p class="mt-2">
            You can join by acquiring $UNTOUCH, participating in our community activities, and engaging with fellow Untouchable Guys through social media and our platform.
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">Is Untouchable Guys just another memecoin?</summary>
          <p class="mt-2">
            No! While we embrace the fun and lightheartedness of memecoins, Untouchable Guys stands out by building a strong, meaningful community and offering real-world utility for $UNTOUCH.
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">What makes $UNTOUCH unique?</summary>
          <p class="mt-2">
            $UNTOUCH isn't just about the laughs—it's about creating lasting connections, rewarding creativity, and fostering a culture of collaboration. Plus, it’s backed by the high-performance Solana blockchain.
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">Why was Solana chosen for Untouchable Guys?</summary>
          <p class="mt-2">
            Solana's fast transactions, low fees, and scalability make it the perfect platform for a memecoin that values both community engagement and seamless performance.
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">How can I buy $UNTOUCH?</summary>
          <p class="mt-2">
            You’ll be able to buy $UNTOUCH through supported Solana wallets and decentralized exchanges like Raydium once the token launches. Stay tuned for updates!
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">What kind of events does the community host?</summary>
          <p class="mt-2">
            From meme-making contests and NFT drops to collaborative projects and interactive challenges, our events are designed to bring the Untouchable Guys community together in creative and fun ways.
          </p>
        </details>
        <details class="bg-gray-700 p-4 rounded-lg">
          <summary class="text-xl font-semibold cursor-pointer">What’s the long-term vision for Untouchable Guys?</summary>
          <p class="mt-2">
            Our vision is to grow $UNTOUCH into a symbol of creativity, resilience, and fun while empowering our community to make an impact in both the blockchain world and beyond.
          </p>
        </details>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
